import React from "react";
import Draft from "draft-js";
import { isEmpty, isPlainObject } from "lodash";
import { DraftDecoratorComponentProps } from "@sonder/editor/typings/editor";
import { StyledLink } from "./StyledLink";

const getHrefFromLinkEntity = (
  contentState: Draft.ContentState,
  entityKey: string,
): string | null => {
  const entityData = contentState.getEntity(entityKey).getData();
  const hasHref = isPlainObject(entityData) && !isEmpty(entityData.href);
  return hasHref ? entityData.href : null;
};

export interface RichLinkProps extends DraftDecoratorComponentProps {}
export const RichLink = ({
  children,
  contentState,
  entityKey,
}: RichLinkProps) => {
  // We only want to wrap the plain text substring in our link component when
  // there is a valid entity associated with it.
  if (!entityKey) return children;
  const href = getHrefFromLinkEntity(contentState, entityKey);
  if (!href) return children;

  return (
    <StyledLink
      data-entity-key={entityKey}
      href={href}
      title={href}
      onClick={() => window.open(href, "_blank")}
    >
      {children}
    </StyledLink>
  );
};
